import ComicCard from '@/components/base/ComicCard';
import { getPopularComics } from '@/mocks/comics';

export default function FeaturedSection() {
  const popularComics = getPopularComics();

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">精选最受欢迎的韩国漫画</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop>
        {popularComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}